(function () {

function main () {
  const root_element = document.getElementById('root_element');

  if (window_api_data.template_name == 'index') {
    render_home(root_element);
  }
  else if (window_api_data.template_name == 'product') {
    render_product(root_element);
  }
  else if (window_api_data.template_name == 'collection') {
    render_collection_breadcrumb(root_element);
    var collection_fins = ['Fins', 'Fins - Twin', 'Fins - Thruster & Quad', 'Fins - Single', 'Fins - All']
    if (collection_fins.includes(window_api_data.collection_title)) {
      render_fins(root_element);
    }
  }
  else if (window_api_data.template_name == 'cart') {
    //render_cart_usa_message();
    render_cart_uk_message();
  }

  fix_clear_color();
  
  render_announcement_bar();
  
  render_modal_cart(root_element);
  
  hide_menu_gift_cards();
  
  render_blogs_list();

  //render_blog();
  
  //privacy_main(root_element);
}

main();

})()
